import RootStore from "../rootStore";
import copyPolygonsHandler from "./copyPolygonsHandler";

const handleFinishLabeling = (history: any) => {
  history.push("/batches/0?sort=createdDate,desc");
};

const goToNextImage = (store: RootStore, history: any) => {
  const { batch, numImage, labeledImages, images } = store.labelerSegmentationStore;

  const {
    setKeepLabelsOnNextImage,
    setAlertDialogText,
    setAlertDialogCallback,
    setAlertDialogCloseCallback,
    setOpenAlertDialog,
  } = store.labelerSegmentationUiStore;

  const finished = labeledImages.length === images.length;
  const isLastImage = numImage == images.length - 1;

  if (finished && isLastImage) {
    setAlertDialogText("La labellisation de ce lot est terminée");
    setAlertDialogCallback(() => {
      handleFinishLabeling(history);
    });
    setAlertDialogCloseCallback(() => {
      handleFinishLabeling(history);
    });
    setOpenAlertDialog(true);
  } else if (!isLastImage) {
    setKeepLabelsOnNextImage(true);
    history.push(`/labelerSegmentation/${batch.id}/${Number(numImage) + 1}`);
  }
};

const saveCopyNextImageHandler = (
  store: RootStore,
  appFetch: any,
  history: any,
  userLogin?: string | null
) => {
  const {
    labelerSegmentationStore: { saveLabelisations, changeMotif, isReadOnly },
  } = store;

  if (isReadOnly) return;

  copyPolygonsHandler(store);
  changeMotif(null, false);

  saveLabelisations(appFetch, userLogin).then(() => {
    if (!store.labelerSegmentationStore.isError) {
      goToNextImage(store, history);
    }
  });
};

export default saveCopyNextImageHandler;
